"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCurrentLocale = void 0;
const useCurrentLocale_1 = __importDefault(require("./useCurrentLocale"));
exports.useCurrentLocale = useCurrentLocale_1.default;
//# sourceMappingURL=index.js.map